export default class OrderBuyer {
  areaCode?: string;
  cellPhone?: string;
  document?: string;
  documentType?: string;
  email?: string;
  integrationType?: string;
  name?: string;
  phone?: string;
}
